import type { ApiCommerceOrder } from "@bridge-applications/pb-types";
import type { TelegramInvoiceStatus } from "./telegram";

export type CommerceOrderClientAction =
    "OPEN_INVOICE" | "WAIT_FOR_SETTLEMENT" | "SUCCEEDED" | "FAILED";

export function commerceOrderClientAction(
    status: ApiCommerceOrder["status"],
): CommerceOrderClientAction {
    switch (status) {
        case "CREATED":
        case "CHECKOUT_PENDING":
            return "OPEN_INVOICE";
        case "PRECHECKOUT_APPROVED":
        case "PAID":
        case "FULFILLING":
        case "REFUND_PENDING":
            return "WAIT_FOR_SETTLEMENT";
        case "FULFILLED":
            return "SUCCEEDED";
        case "FAILED":
        case "CANCELLED":
        case "REFUNDED":
            return "FAILED";
    }
}

export function shouldPollAfterInvoiceStatus(
    status: TelegramInvoiceStatus,
): boolean {
    return status === "paid" || status === "pending";
}

export function commerceOrderPaymentWasAccepted(
    status: ApiCommerceOrder["status"],
): boolean {
    return (
        status === "PAID" || status === "FULFILLING" || status === "FULFILLED"
    );
}
